"use client";

import React from 'react';
import { DynamicContentSection } from './DynamicContentSection';

interface TeamDrivenSectionProps {
    contentKey?: string;
}

export const TeamDrivenSection: React.FC<TeamDrivenSectionProps> = ({ contentKey = 'teamDriven' }) => {
    return (
        <DynamicContentSection 
            contentKey={contentKey}
            layout="image-left"
            showCta={false}
            showSingleImage={true}
            showBottomLine={true} // Explicitly enable bottom line for this section
            image1Src="/images/ciscode_company_hq.png"
            image1Alt="Team at work"
        />
    );
};